var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nowrap"},[_c('img',{staticClass:"noimg",attrs:{"src":require('@/assets/image/nodata.png')}}),_c('aside',{staticClass:"notip"},[_vm._v("没有搜索到您想要的素材?")]),_c('aside',{staticClass:"resetsearch"},[_vm._v("重新搜索")]),_c('p',{staticClass:"kf"},[_vm._v("客服电话：135-2235-2793（微信同步）")])])
}
var staticRenderFns = []

export { render, staticRenderFns }